import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

import AmplifyVue from '@aws-amplify/ui-vue'
import { Amplify } from 'aws-amplify'
import config from './amplifyconfiguration.json'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import naive from 'naive-ui'

import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { useAuthenticator } from '@aws-amplify/ui-vue'
import { useAuthStore } from './stores/auth'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { RecaptchaV2, install as installRecaptcha } from 'vue3-recaptcha-v2'
import { startIdleSessionWatch } from './utils/sessionIdle'

Amplify.configure(config)

const app = createApp(App)
app.use(naive)
app.use(VueAxios, axios)
app.use(installRecaptcha, {
  sitekey: ''
})
app.component('vue-recaptcha', RecaptchaV2)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)

const authStore = useAuthStore()
authStore.authenticator = useAuthenticator()
setTimeout(function () {
  app.use(router)
  app.use(AmplifyVue)
  app.mount('#app')
  startIdleSessionWatch(() => {
    router.push({ path: '/login' })
  })
}, 1)
